import { render } from "./tasks.vue?vue&type=template&id=5976ff7c&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"

import "./tasks.vue?vue&type=style&index=0&id=5976ff7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5976ff7c"]])

export default __exports__